module.exports = __webpack_public_path__ + "static/media/AllertaStencil-Regular.11798c51.ttf";